'use client';

import { GetWrapupType } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleWelcomeComponent from "./welcomecomponent";

export default class WrapupModuleWelcome implements IWrapupModule {
    constructor() { }

    get id(): string { return 'welcome'; }
    get name(): string { return 'Welcome'; }

    canRender(data: GetWrapupType): boolean {
        return true;
    }

    getComponentClass() {
        return WrapupModuleWelcomeComponent;
    }
}
